import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Textarea from 'react-textarea-autosize';
import { CLOSE_ACTION_MODAL_CHILD, OPEN_ACTION_MODAL_CHILD } from '../../../../redux/actions/componentsActions';
import {
    CLOSE_AMBASSADOR_DIALOG,
    CLOSE_DIALOG,
    FLAG_DIALOG,
    LEAVE_CHAT,
} from '../../../../redux/actions/dialogsActions';
import ProspectMessagingHeader from './ProspectMessagingHeader';
import AmbassadorMessagingHeader from './AmbassadorMessagingHeader';
import '../../../../assets/styles/custom/components/messaging_header.scss';
import { Button } from 'antd';

const MessagingHeader = ({ currentChat, isMobile, openFeedbackPopup }) => {
    const dispatch = useDispatch();

    const account = useSelector((state) => state.account);

    const [showOptions, setShowOptions] = useState(false);
    const [reportedReason, setReportedReason] = useState(null);

    const listenerRef = React.useRef({ reportedReason, currentChat });

    useEffect(() => {
        listenerRef.current = { reportedReason, currentChat };
    }, [reportedReason, currentChat]);

    const handleFlagClick = useCallback(() => {
        const { reportedReason, currentChat } = listenerRef.current;
        if (reportedReason.length === 0) {
            if (reportedReason.trim().length === 0) {
                document.getElementById('text-close-flag').classList.add('error-flag-field');
            } else {
                document.getElementById('text-close-flag').classList.remove('error-flag-field');
            }
        } else {
            handleClosePopup();
            dispatch({
                type: FLAG_DIALOG,
                payload: {
                    dialog_id: currentChat.data.id,
                    reported_reason: reportedReason,
                },
            });
        }
    }, [dispatch]);

    const closeDialog = useCallback(() => {
        handleClosePopup();
        const dialog = listenerRef.current.currentChat;
        if (!dialog.closed) {
            if (account.account_info.key === 'prospect') {
                dispatch({
                    type: CLOSE_DIALOG,
                    payload: {
                        dialog_id: dialog.activeChat,
                    },
                    onSuccess: openFeedbackPopup,
                });
            } else {
                dispatch({
                    type: CLOSE_AMBASSADOR_DIALOG,
                    payload: {
                        dialog_id: dialog.activeChat,
                    },
                });
            }
        }
    }, [dispatch, account, openFeedbackPopup]);

    const handleFlagTextChange = useCallback((event) => {
        setReportedReason(event.target.value);
        document.getElementById('text-size-flagged').innerText = event.target.value.length;
        if (event.target.value.trim().length === 0) {
            document.getElementById('text-close-flag').classList.add('error-flag-field');
            document.getElementById('text-size-flagged').classList.add('error-flag-count');
        } else {
            document.getElementById('text-close-flag').classList.remove('error-flag-field');
            document.getElementById('text-size-flagged').classList.remove('error-flag-count');
        }
    }, []);

    const handleSurePopupClick = useCallback(
        (methodStr, subtitle, isFlag) => {
            hideOptions();
            let textareaBlock = '';
            const method = () => {
                switch (methodStr) {
                    case 'handleFlagClick':
                        handleFlagClick();
                        break;
                    case 'closeDialog':
                        closeDialog();
                        break;
                    case 'leaveChat':
                        leaveChat();
                        break;
                }
            };
            if (isFlag) {
                textareaBlock = (
                    <div className="text-close-flag-block">
                        {isMobile ? <span>What went wrong?</span> : null}
                        <Textarea
                            onKeyUp={handleFlagTextChange}
                            minRows={1}
                            maxRows={9}
                            maxLength="140"
                            id="text-close-flag"
                            type="text"
                            placeholder={!isMobile ? 'What went wrong?' : ''}
                            className={`text-close-flag ${isMobile ? 'mobile' : ''}`}
                            aria-required="true"
                            aria-label="Tell us what went wrong"
                        />
                        <span className="text-size-flagged">
                            <span id="text-size-flagged" aria-live="polite">
                                0
                            </span>
                            /{140}
                        </span>
                    </div>
                );
            }
            dispatch({
                type: OPEN_ACTION_MODAL_CHILD,
                payload: {
                    children: (
                        <div className="general-popup" id="verification">
                            <h2 className="modal-title">{isFlag ? 'Report a conversation?' : 'Are you sure?'}</h2>
                            {subtitle}
                            {textareaBlock}
                            <div className={'btn-wrap confirm-ban-buttons' + (isFlag ? ' flag-close-buttons' : '')}>
                                <Button type="submit" className="el-btn general-action-button" onClick={method}>
                                    Confirm
                                </Button>
                                {isFlag && isMobile ? null : (
                                    <Button
                                        type="submit"
                                        className="el-btn general-action-button cancel"
                                        onClick={handleClosePopup}
                                    >
                                        Cancel
                                    </Button>
                                )}
                            </div>
                        </div>
                    ),
                },
            });
        },
        [dispatch, isMobile]
    );

    const hideOptions = useCallback(() => {
        setShowOptions(false);
    }, []);

    const handleClosePopup = useCallback(() => {
        dispatch({
            type: CLOSE_ACTION_MODAL_CHILD,
        });
    }, [dispatch]);

    const handleShowOptionsClickOnMobile = useCallback(() => {
        setShowOptions(!showOptions);
    }, [showOptions]);

    const leaveChat = useCallback(() => {
        const { currentChat } = listenerRef.current;
        const dialogId = currentChat.activeChat;
        dispatch({
            type: LEAVE_CHAT,
            payload: { dialogId },
        });
    }, [dispatch]);

    return (
        <div className={'chat-head' + (account.account_info.key === 'prospect' ? ' prospect-head' : '')}>
            {account.account_info.key === 'prospect' ? (
                <ProspectMessagingHeader
                    handleSurePopupClick={handleSurePopupClick}
                    isMobile={isMobile}
                    handleShowOptionsClickOnMobile={handleShowOptionsClickOnMobile}
                    showOptions={showOptions}
                />
            ) : (
                <AmbassadorMessagingHeader
                    handleSurePopupClick={handleSurePopupClick}
                    isMobile={isMobile}
                    handleShowOptionsClickOnMobile={handleShowOptionsClickOnMobile}
                    showOptions={showOptions}
                    hideOptions={hideOptions}
                />
            )}
        </div>
    );
};

export default MessagingHeader;
